import { forwardRef, type SVGProps } from 'react';

/**
 * SetupSensorIcon component
 *
 * @param props - SVG props
 */
const SetupSensorIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width={20}
      height={21}
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <mask
        id='path-1-outside-1_14147_35320'
        maskUnits='userSpaceOnUse'
        x={0}
        y={0}
        width={20}
        height={21}
        fill='black'
      >
        <rect fill='white' width={20} height={21} />
        <path d='M0 0H20V20H0V0Z' />
      </mask>
      <path
        d='M0 20.5H0.5V19.5H0V20.5ZM1.5 20.5H2.5V19.5H1.5V20.5ZM3.5 20.5H4.5V19.5H3.5V20.5ZM5.5 20.5H6.5V19.5H5.5V20.5ZM7.5 20.5H8.5V19.5H7.5V20.5ZM9.5 20.5H10.5V19.5H9.5V20.5ZM11.5 20.5H12.5V19.5H11.5V20.5ZM13.5 20.5H14.5V19.5H13.5V20.5ZM15.5 20.5H16.5V19.5H15.5V20.5ZM17.5 20.5H18.5V19.5H17.5V20.5ZM19.5 20.5H20V19.5H19.5V20.5ZM0 21H0.5V19H0V21ZM1.5 21H2.5V19H1.5V21ZM3.5 21H4.5V19H3.5V21ZM5.5 21H6.5V19H5.5V21ZM7.5 21H8.5V19H7.5V21ZM9.5 21H10.5V19H9.5V21ZM11.5 21H12.5V19H11.5V21ZM13.5 21H14.5V19H13.5V21ZM15.5 21H16.5V19H15.5V21ZM17.5 21H18.5V19H17.5V21ZM19.5 21H20V19H19.5V21Z'
        fill='currentColor'
        mask='url(#path-1-outside-1_14147_35320)'
      />
      <path
        d='M9.99996 1.66669C5.39996 1.66669 1.66663 5.40002 1.66663 10C1.66663 14.6 5.39996 18.3334 9.99996 18.3334C14.6 18.3334 18.3333 14.6 18.3333 10C18.3333 5.40002 14.6 1.66669 9.99996 1.66669ZM10.8333 14.1667H9.16663V12.5H10.8333V14.1667ZM10.8333 10.8334H9.16663V5.83335H10.8333V10.8334Z'
        fill='currentColor'
      />
    </svg>
  )
);

SetupSensorIcon.displayName = 'SetupSensorIcon';

export default SetupSensorIcon;
